import config from '../../../config/config';
import DefaultApiLimit from '../../../config/defaultLimit';
import deleteRequest from '../base/delete';
import getRequest from '../base/get';
import patchRequest from '../base/patch';
import postRequest from '../base/post';

interface QueryParameters {
  limit?: number;
  [key: string]: any;
}

export default {
  /**
   * Add guest charging station API
   * @param {any} data Guest charging station data
   */
  addGuestCharging: (data: any): Promise<any> => {
    return postRequest(`${config.commonApiUrl}api/facility/v1/free-charging`, data, false);
  },
  /**
   * Transactions show API
   * @param {any} query Query parameters
   * @returns {any} List of guest charging transactions
   */
  fetchGuestChargingList: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/facility/v1/charging-station/free-charging-schedules`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Guest charging filter
   * @param {any} query Query parameters
   * @returns {any} List of guest charging filters
   */
  fetchGuestChargingListFilter: (query: QueryParameters) => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/facility/v1/charging-station/free-charging-schedules/list-filters`,
      {
        ...parameters,
      },
    );
  },
  /**
   * Fetch guest charging stations API
   * @param {any} query Query parameters
   */
  fetchGuestCharging: (query: QueryParameters = {}) => {
    const parameters = { ...query, limit: query?.limit || DefaultApiLimit.limit };
    return getRequest(`${config.commonApiUrl}api/facility/v1/free-charging`, {
      ...parameters,
    });
  },
  /**
   * Fetch guest charging stations API for export
   * @param {any} query Query parameters
   */
  fetchGuestChargingExport: (query: QueryParameters = {}) => {
    const parameters = { ...query };
    return getRequest(`${config.commonApiUrl}api/facility/v1/free-charging/export-data`, {
      ...parameters,
    });
  },
  /**
   * Fetch guest charging history API
   * @param {any} id Guest charging station id
   */
  historyGuestCharging: (id: string): Promise<any> => {
    return getRequest(`${config.commonApiUrl}api/facility/v1/free-charging/history-list/${id}`, {});
  },
  /**
   * Edit guest charging API
   * @param {any} id Guest charging station id
   * @param {any} data Guest charging data
   */
  editGuestCharging: (id: string, data: any): Promise<any> => {
    return patchRequest(`${config.commonApiUrl}api/facility/v1/free-charging/${id}`, data, false);
  },
  /**
   * Edit guest charging status API
   * @param {any} id Guest charging station id
   * @param {any} data Status data
   */
  editGuestChargingStatus: (id: string, data: any): Promise<any> => {
    return patchRequest(
      `${config.commonApiUrl}api/facility/v1/charging-station/status/${id}`,
      data,
      false,
    );
  },
  /**
   * Delete guest charging station API
   * @param {any} id Guest charging station id
   */
  deleteGuestCharging: (id: string): Promise<any> => {
    return deleteRequest(`${config.commonApiUrl}api/facility/v1/free-charging/${id}`);
  },

  /**
   * Fetch guest charging list filters API
   * @returns {any} List of guest charging list filters
   */
  fetchListFilters: () => {
    return getRequest(`${config.commonApiUrl}api/facility/v1/free-charging/list-filters`);
  },

  /**
   * Update guest charging status
   * @param {any} id Guest charging station id
   * @param {any} data Status data
   * @returns {any} Update result
   */
  updateGuestStatus: (id: string, data: any): Promise<any> => {
    return patchRequest(
      `${config.commonApiUrl}api/facility/v1/free-charging/updateActiveStatus/${id}`,
      data,
      false,
    );
  },
  /**
   * Fetch guest details API
   * @param {any} guestId - Guest ID
   */
  fetchGuestDetails: (guestId: string) => {
    return getRequest(`${config.reportApiUrl}api/facility/v1/free-charging/${guestId}`);
  },
};
